// ========================================
// VITE ENTRY POINT - DETECTIMÁTICAS
// ========================================

// 1. Estilos Globales (Unificados + Focus Mode)
import './css/unified.css';
import './css/focus-mode.css';

// 2. EventBus, Haptics y Logger (Primero)
import './js/event-bus.js';
import './js/haptics-service.js';
import './js/dynamicAdapter.js';
import './js/pdfReportService.js';
import './js/lomloeRadarChart.js';
import './js/abnManipulativeBoard.js';
import './js/logger.js';

// 2.5 SCORM y Analíticas
import ScormManager from './js/scorm-manager.js';

// 3. Configuración
import './config/branding.js';
import './config/languages.js';
import './config/excelMapping.js';
import './config/contexts.js';
import './config/narratives.js';
import './config/questionnaire.js';
import './config/api.js';
import './config/loaderConfig.js';
import './config/xpSystem.js';
import './config/contextTables.js';
import './config/semanticMappings.js';

// 4. Librerías de Terceros (Esenciales)
import { gsap } from 'gsap';
import confetti from 'canvas-confetti';

window.gsap = gsap;
window.confetti = confetti;

// 4.5 Image Zoom Handler
import './js/imageZoomHandler.js';

// 5. Servicios e Infraestructura Base
import './js/errorHandling.js';
import './js/telemetry.js';
import './js/audio-manager.js';
import './js/elevenlabs-tts.js';
import './js/pwaInstall.js';

// 6. Lógica de Usuario y Mentor
import './js/userManager.js';
import './js/demoDataGenerator.js';
import './js/detectiveMentor.js';
import './js/loginLogic.js';
import './js/parentsDashboard.js';

// 7. Core Managers
import './js/ui-manager.js';
import './js/session-manager.js';
import './js/config-manager.js';
import './js/summary-manager.js';
import './js/problem-logic.js';

// 8. Utilidades
import './js/grammarUtils.js';
import './js/contextualNarratives.js';
import './js/textSegmentation.js';
import './js/abnHelper_v3.js';

// 9. Generación de Problemas
import './js/problemGenerator.js';
import './js/customProblemManager.js';
import './js/excelCache.js';
import './js/loaderUI.js';
import './js/offline-data-gen.js'; // Auto-generated offline data
import './js/offline-help-data-gen.js'; // Auto-generated offline help data
import './js/excelLoader.js';
import './js/problemHelpModal.js';
import './js/problemEditor.js';
import './js/problemStorage.js';
import './js/reportGenerator.js';
import './js/printProblem.js';

// 10. Agentes
import './js/mathAgent.js';
import './js/semanticValidator.js';
import './js/narrativeAgent.js';
import './js/visualAgent.js';

// 11. Wizard Modular
import './js/wizardMain.js';

// 12. Gamificación e Integraciones
import './js/badgeSystem.js';
import './js/gamificationService.js';
import './js/adventureMap.js';
import './js/phase1Integration.js';
import './js/phase2Integration.js';
import './js/smartFeedback.js';
import './js/recommendationEngine.js';

import './js/stickerStore.js';
import './js/appGuide.js';
import './js/workBoard.js';
import './js/narrativeManager.js';
import './js/accessibilityManager.js';
import './js/spatialNavigation.js';
import './js/curricularGamification.js';
import { initGlobalEvents } from './js/globalEvents.js';
import './js/components/GdprModal.js';
import './js/components/QuickConfigModal.js';
import './js/components/DetectiveZoneModal.js';

// ========================================
// INITIALIZATION
// ========================================
Logger.info('🚀 DETECTIMÁTICAS - APP INICIADA');

// Inyectar HTML Modales extraídos (Fragmentación Arquitectura Fase 1)
import modalsHTML from './html/modals.html?raw';
if (typeof document !== 'undefined' && !document.getElementById('authModal')) {
    document.body.insertAdjacentHTML('beforeend', modalsHTML);
}


// --- DEBUG: VISUAL ERROR LOGGER REMOVED (Moved to index.html) ---

// State Setup
window.currentLanguage = 'es-ES';
import { store } from './js/store.js';
Object.assign(store.config, {
    problemType: null, level: null, context: null, currentStep: 1, mode: 'offline',
    contextExplicit: true // true = user explicitly chose context, false = randomly assigned
});

// Main Initialization Function
function initializeApp() {
    // Inicializar SCORM antes que nada
    if (window.ScormManager) window.ScormManager.init();

    // Inicializar User Manager
    if (window.UserManager) window.UserManager.init();
    if (window.UIManager) window.UIManager.init();
    initGlobalEvents();

    // Setup Login Buttons (Rescue Binding)
    setupLoginButtons();

    // Setup Config Event Listeners (Back/Next)
    if (window.setupConfigEventListeners) window.setupConfigEventListeners();

    // Inicializar UI si ya estamos dentro (recarga de página logged in)
    if (window.UserManager && window.UserManager.isLoggedIn()) {
        restoreSession();
    } else {
        // No forzamos la pantalla de login para permitir que se vea la Splash Screen inicial
        Logger.info('👋 Perfil de invitado o no logueado - Manteniendo Splash Screen');
    }
}

// Ensure Login Buttons Work
function setupLoginButtons() {
    const newBtn = document.getElementById('newProfileBtn');
    if (newBtn) {
        newBtn.onclick = () => {
            if (window.showProfileModal) window.showProfileModal();
            else {
                const modal = document.getElementById('newProfileModal');
                if (modal) {
                    modal.classList.remove('hidden');
                    if (window.LoginScreen) window.LoginScreen.renderAvatarOptions();
                }
                // Focus logic
                const input = document.getElementById('newProfileName');
                if (input) input.focus();
            }
        };
    }

    const guestBtn = document.getElementById('guestBtn');
    if (guestBtn) {
        guestBtn.onclick = () => {
            if (window.UserManager) {
                window.UserManager.loginGuest();

                if (window.GamificationService) window.GamificationService.init();
                if (window.StickerStore) window.StickerStore.loadInventory();
                
                if (window.SessionManager) window.SessionManager.showWelcomeScreen();
                if (window.DetectiveMentor) window.DetectiveMentor.init();
            }
        };
    }
}

function restoreSession() {
    if (window.GamificationService) window.GamificationService.init();
    if (window.DetectiveMentor) { window.DetectiveMentor.init(); window.DetectiveMentor.show(); }
    if (window.AdventureMap) window.AdventureMap.init();

    // Show welcome directly
    if (window.SessionManager) window.SessionManager.showWelcomeScreen();
}


// Start App
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
